<template>
  <div class="authentication-layout">
    <main class="main">
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex shrink>
            <div class="form">
              <slot name="form-header" />
              <slot name="form-content" />
            </div>

            <nav class="navigation">
              <slot name="navigation" />
            </nav>
          </v-flex>
        </v-layout>
      </v-container>
    </main>

    <aside class="sidebar">
      <docgo-brand />

      <div class="hero">
        <div class="text">
          <h2 class="title">Documentos Eletrônicos</h2>
          <p class="subtitle">Faça a gestão dos processos e documentos com agilidade e segurança jurídica em um único local.</p>

<!--          <v-btn round outline dark color="default">-->
<!--            <v-icon left>mdi-play-circle</v-icon> Veja como funciona-->
<!--          </v-btn>-->
        </div>

        <div class="image">
          <img src="/static/images/authentication/digital-document.svg" alt="Documento Eletrônico">
        </div>
      </div>

      <footer class="footer" style="height: 100px">
<!--        <a class="help-link" href="https://docgo.com.br/faq" title="Central de Atendimento DocGo">-->
<!--          <v-icon class="icon">mdi-help-circle-outline</v-icon>-->
<!--          <div class="text">-->
<!--            <strong>Alguma dúvida?</strong>-->
<!--            <span>Fale com a gente.</span>-->
<!--          </div>-->
<!--        </a>-->
      </footer>
    </aside>
  </div>
</template>

<script>
import DocgoBrand from '@/components/base/DocgoBrand';

export default {
  name: 'AuthenticationLayout',
  components: {
    DocgoBrand,
  },
};
</script>

<style lang="scss">
.authentication-layout {
  & {
    display: grid;
    grid-template-areas: "sidebar main";
    grid-template-rows: 1fr;
    grid-template-columns: minmax(460px, 1fr) 2fr;
    height: 100vh;
    overflow: hidden;
  }

  > .main {
    background: #fff;
    padding: 0 6rem;
    grid-area: main;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  > .sidebar {
    & {
      padding: 3rem;
      grid-area: sidebar;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #2E8BFF url("/static/images/authentication/sidebar-background.jpg") left bottom no-repeat;
      background-size: contain;
      color: white;
    }

    > .header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    > .hero {
      & {
        position: relative;
      }

      > .text {
        width: 320px;
        > .title {
          margin-bottom: 1rem;
        }
        > .subtitle {
          margin-bottom: 2rem;
        }
      }

      > .image {
        position: absolute;
        top: 50%;
        right: -3rem;
        transform: translate(50%, -50%);
        min-width: 50%;

        img {
          width: 100%;
          height: auto;
        }
      }
    }

    > .footer {
      > .help-link {
        & {
          display: flex;
          flex-direction: row;
          text-decoration: none;
        }

        .icon {
          margin-right: 1rem;
          color: #fff;
        }

        .text {
          & {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            text-transform: none;
            color: #fff;
          }

          > .title {
            margin-bottom: 1rem;
          }
        }

        &:hover {
          .text {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/AuthenticationLayout.vue